const areSameRegularProduct = (serverLineItem, draftLineItem) => {
  if (serverLineItem.__typename !== "LineItemRegular") {
    return false;
  }
  return serverLineItem.sku === draftLineItem.sku;
};
export {
  areSameRegularProduct
};
//# sourceMappingURL=are-same-regular-product.js.map
